const initialState = {};

// -------------------------------------------------------
// -------------------------------------------------------
const reducer = (state = initialState, action) => {
  // -------------------------------------------------------
  switch (action.type) {
    case "SET_ADVANCE_DATA":
      return { ...state, advance: action.advance };

    default:
      return state;
  }
};

export default reducer;
